// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"c8d6e85f","3091":"c8d6e85f","5472":"c8d6e85f","8153":"c8d6e85f","9002":"c8d6e85f"}[chunkId] + ".chunk.css";
};